import { getGdprAdsStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

export const setGdprAdsVersion = mutatorAction('setGdprAdsVersion', (gdprVersion: number) => {
    // Set the gdprAdsVersion to trigger the store change
    getGdprAdsStore().gdprAdsVersion = gdprVersion;
});
